import { useState } from "react";
import SEO from "../components/SEO";
import { PUBLIC_FAQ_ITEMS } from "@shared/seoFaq";

const faqs = PUBLIC_FAQ_ITEMS;

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map(f => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <>
      <SEO
        title="Wholesale Pharmacy FAQs: Pricing, Orders & DSCSA"
        description="Answers to common questions about Premier Pharma — accounts, wholesale pricing, DSCSA compliance, product categories, ordering, and ScriptTrack software."
        jsonLd={faqJsonLd}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "FAQs", path: "/faq" },
        ]}
      />
      <section className="py-20 bg-gradient-to-br from-background to-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-accent text-sm font-semibold uppercase tracking-wider">FAQs</span>
          <h1 className="text-4xl font-bold text-primary mt-2 mb-8">Wholesale Pharmacy FAQs: Pricing, Orders & DSCSA</h1>

          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div key={i} className="card">
                <button
                  type="button"
                  className="w-full flex justify-between items-center text-left"
                  aria-expanded={openIndex === i}
                  aria-controls={`faq-answer-${i}`}
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                >
                  <span className="font-semibold text-primary pr-4">{faq.q}</span>
                  <svg className={`w-5 h-5 text-accent flex-shrink-0 transition-transform ${openIndex === i ? "rotate-180" : ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                <div id={`faq-answer-${i}`} hidden={openIndex !== i}>
                  <p className="text-gray-600 text-sm mt-3 pt-3 border-t border-gray-100">{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
